<template>
  <div v-if="qa !== null">
    <!-- FAQ -->
    <div class="block mb-5">
      <!-- 問題 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>問題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="qa.question"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 分類 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>分類</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="qa.faq_category_id"
            :items="categories"
            placeholder="請選擇所屬分類"
            item-text="title"
            item-value="id"
            outlined
            dense>
          </v-autocomplete>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="qa.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="qa.status"></FormSwitch>
        </div>
      </div>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="qa.ans"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold'"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    FormSwitch,
    Editor,
  },
  data: () => ({
    status: true,
    categories: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('resqa', ['qa']),
  },
  async created() {
    if (this.qa.faq_category_id !== null) {
      this.categories = await this.getQACates(this.qa.faq_category_id);
    }
  },
  watch: {
    async 'qa.faq_category_id'(newValue) {
      if (newValue !== '') {
        this.categories = await this.getQACates(newValue);
      } else {
        this.categories = [];
      }
    },
  },
  methods: {
    ...mapActions('resqa', ['getQACates']),
  },
};
</script>
<style></style>
